import moment from 'moment';
import { Fragment } from 'react';

import { ResourceChip, Text } from 'shell/components';

const files = [
    {
        id: '1',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        data: { name: 'Microsoft Analysis.pdf', type: 'application/pdf' },
    },
    {
        id: '2',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        data: {
            name: 'Microsoft Analysis.docx',
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        },
    },
    {
        id: '3',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        data: {
            name: 'Microsoft Analysis.xlsx',
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
    },
    {
        id: '4',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        data: {
            name: 'Microsoft Analysis.pptx',
            type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        },
    },
    {
        id: '5',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        data: { name: 'Microsoft Analysis.zip', type: 'application/zip' },
    },
    {
        id: '6',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        data: { name: 'Microsoft Analysis.jpg', type: 'image/jpeg' },
    },
    {
        id: '7',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        data: { name: 'Microsoft Analysis.ext', type: 'any' },
    },
    {
        id: '8',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        data: { name: 'Very very very very long item name.ext', type: 'any' },
    },
    {
        id: '9',
        active: false,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        data: { name: 'Very very very very long item name.ext', type: 'any' },
    },
    {
        id: '10',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        data: { name: 'Very very very very long item name.ext', type: 'any' },
        loading: true,
    },
];

const links = [
    {
        id: '1',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        name: 'Link name',
        url: 'www.ensightful.app',
    },
    {
        id: '2',
        active: true,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        name: 'Very very very very long link name',
        url: 'www.ensightful.app',
    },
    {
        id: '3',
        active: false,
        created_on: moment().subtract(5, 'minute').valueOf(),
        owner_account_id: '1',
        name: 'Very very very very long link name',
        url: 'www.ensightful.app',
    },
];

const ResourceChipDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>ResourceChip</Text>
            {files.map((file) => (
                <Fragment key={file.id}>
                    <ResourceChip
                        options={[
                            { key: 'download', value: 'Download' },
                            { key: 'delete', value: 'Delete' },
                        ]}
                        resource={file}
                        size={'small'}
                        type={'file'}
                        onSelect={console.log}
                    />
                    <ResourceChip
                        options={[
                            { key: 'download', value: 'Download' },
                            { key: 'delete', value: 'Delete' },
                        ]}
                        resource={file}
                        size={'medium'}
                        type={'file'}
                        onSelect={console.log}
                    />
                </Fragment>
            ))}
            {links.map((link) => (
                <Fragment key={link.id}>
                    <ResourceChip
                        options={[
                            { key: 'visit', value: 'Visit Link' },
                            { key: 'copy', value: 'Copy Link' },
                            { key: 'remove', value: 'Remove' },
                        ]}
                        resource={link}
                        size={'small'}
                        type={'link'}
                        onSelect={console.log}
                    />
                    <ResourceChip
                        options={[
                            { key: 'visit', value: 'Visit Link' },
                            { key: 'copy', value: 'Copy Link' },
                            { key: 'remove', value: 'Remove' },
                        ]}
                        resource={link}
                        size={'medium'}
                        type={'link'}
                        onSelect={console.log}
                    />
                </Fragment>
            ))}
        </>
    );
};

export default ResourceChipDemo;
